import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'

const state = {
  tasks: [],
  relatedTasks: [],
  task: {},
  userTask: {},
  claimedTasks: [],
  unclaimedTasks: [],
  claimedTaskHistory: [],
  claimedGroupTaskItems: [],
  unClaimedGroupTaskItems: [],
  ownTasks: [],
  approvedTasks: [],
  comments: [],
  execution: {},
  selectedTaskForApproval: {},
  taskCandidateUsers: [],
  taskHistory: [],
  totalTasks: 0,
  totalAssignedTasks: 0,
  totalClaimedGroupTaskItems: 0,
  totalUnClaimedGroupTaskItems: 0,
  totalGroupTasks: 0,
  totalOwnTasks: 0,
  taskForMaintenance: [],
  taskGroups: [],
  taskGroupHeaders: [],
  associatedFormKeys: {},
  taskCountByFormKey: []
}

const mutations = {
  setTasksForMaintenance(state, tasks) {
    state.taskForMaintenance = tasks
  },
  setTasks(state, tasks) {
    state.tasks = tasks
  },
  setRelatedTasks(state, relatedTasks) {
    state.relatedTasks = relatedTasks
  },
  setUserTask(state, userTask) {
    state.userTask = userTask
  },
  setTask(state, task) {
    state.task = task
  },
  setClaimedTasks(state, tasks) {
    state.claimedTasks = tasks
  },
  setClaimedGroupTaskItems(state, claimedGroupTaskItems) {
    state.claimedGroupTaskItems = claimedGroupTaskItems
  },
  setUnClaimedGroupTaskItems(state, unClaimedGroupTaskItems) {
    state.unClaimedGroupTaskItems = unClaimedGroupTaskItems
  },
  addClaimedGroupTaskItems(state, tasks) {
    state.claimedGroupTaskItems = _.unionWith(
      state.claimedGroupTaskItems,
      tasks,
      _.isEqual
    )
  },
  addUnClaimedGroupTaskItems(state, tasks) {
    state.unClaimedGroupTaskItems = _.unionWith(
      state.unClaimedGroupTaskItems,
      tasks,
      _.isEqual
    )
  },
  setTotalClaimedGroupTaskItems(state, totalClaimedGroupTaskItems) {
    state.totalClaimedGroupTaskItems = totalClaimedGroupTaskItems
  },
  setTotalUnClaimedGroupTaskItems(state, totalUnClaimedGroupTaskItems) {
    state.totalUnClaimedGroupTaskItems = totalUnClaimedGroupTaskItems
  },
  setTaskGroups(state, taskGroups) {
    state.taskGroups = taskGroups
  },
  setTaskGroupHeader(state, taskGroupHeaders) {
    state.taskGroupHeaders = taskGroupHeaders
  },
  setAssociatedFormKeys(state, associatedFormKeys) {
    state.associatedFormKeys = associatedFormKeys
  },
  setOwnTasks(state, tasks) {
    state.ownTasks = tasks
  },
  setApprovedTasks(state, tasks) {
    state.approvedTasks = tasks
  },
  setUnclaimedTasks(state, tasks) {
    state.unclaimedTasks = tasks
  },
  addClaimedTasks(state, tasks) {
    state.claimedTasks = _.unionWith(state.claimedTasks, tasks, _.isEqual)
  },
  addOwnTasks(state, tasks) {
    state.ownTasks = _.unionWith(state.ownTasks, tasks, _.isEqual)
  },
  addUnclaimedTasks(state, tasks) {
    state.unclaimedTasks = _.unionWith(state.unclaimedTasks, tasks, _.isEqual)
  },
  setTaskComments(state, comments) {
    state.comments = comments
  },
  setTaskExecution(state, execution) {
    state.execution = execution
  },
  setTaskCandidateUsers(state, candidateUsers) {
    state.taskCandidateUsers = candidateUsers
  },
  setTaskHistory(state, taskHistory) {
    state.taskHistory = taskHistory
  },
  setTotalTasks(state, totalCount) {
    state.totalTasks = totalCount
  },
  setTotalAssignedTasks(state, totalCount) {
    state.totalAssignedTasks = totalCount
  },
  setTotalGroupTasks(state, totalCount) {
    state.totalGroupTasks = totalCount
  },
  setTotalOwnTasks(state, totalCount) {
    state.totalOwnTasks = totalCount
  },
  setSelectedTaskForApproval(state, selectedTaskForApproval) {
    state.selectedTaskForApproval = selectedTaskForApproval
  },
  setTaskCountByFormKey(state, taskCountByFormKey) {
    state.taskCountByFormKey = taskCountByFormKey
  },
  setTaskInProgress(state, taskId) {
    if (state.selectedTaskForApproval.id === taskId) {
      state.selectedTaskForApproval.inProgress = true
    }

    if (state.tasks.find(task => task.id === taskId)) {
      state.tasks.find(task => task.id === taskId).inProgress = true
    }
    if (state.claimedTasks.find(task => task.id === taskId)) {
      state.claimedTasks.find(task => task.id === taskId).inProgress = true
    }
    if (state.ownTasks.find(task => task.id === taskId)) {
      state.ownTasks.find(task => task.id === taskId).inProgress = true
    }
    if (state.unclaimedTasks.find(task => task.id === taskId)) {
      state.unclaimedTasks.find(task => task.id === taskId).inProgress = true
    }
  },
  setTasksInProgress(state, taskList) {
    taskList.forEach(item => {
      if (state.tasks.find(task => task.id === item)) {
        state.tasks.find(task => task.id === item).inProgress = true
      }
      if (state.claimedTasks.find(task => task.id === item)) {
        state.claimedTasks.find(task => task.id === item).inProgress = true
      }
      if (state.ownTasks.find(task => task.id === item)) {
        state.ownTasks.find(task => task.id === item).inProgress = true
      }
      if (state.unclaimedTasks.find(task => task.id === item)) {
        state.unclaimedTasks.find(task => task.id === item).inProgress = true
      }
    })
  }
}

function processResp(obj) {
  if (obj.created || obj.createdAt) {
    obj.createdAtLocal = moment(obj.created || obj.createdAt)
      .utc()
      .local()
      .format('DD MMM YYYY hh:mm:ss a')
    obj.createdAtDate = moment(obj.created || obj.createdAt)
      .utc()
      .local()
      .format('YYYY-MM-DD')
  }
  if (obj.completedAt) {
    obj.completedAtLocal = moment(obj.completedAt)
      .utc()
      .local()
      .format('DD MMM YYYY hh:mm:ss a')
  }
  if (obj.due) {
    obj.dueLocal = moment(obj.due)
      .utc()
      .local()
      .format('DD MMM YYYY hh:mm:ss a')
    obj.dueAtDate = moment(obj.due)
      .utc()
      .local()
      .format('YYYY-MM-DD')
  } else {
    obj.dueLocal = null
    obj.dueAtDate = null
  }
  if (obj.followUp) {
    obj.followUpLocal = moment(obj.followUp)
      .utc()
      .local()
      .format('DD MMM YYYY hh:mm:ss a')
    obj.followUpDate = moment(obj.followUp)
      .utc()
      .local()
      .format('DD MMM YYYY')
  } else {
    obj.followUpLocal = 'Not Set'
    obj.followUpDate = 'Not Set'
  }
  if (obj.time) {
    obj.timeLocal = moment(obj.time)
      .utc()
      .local()
      .fromNow()
  }
  if (obj.removalTime) {
    obj.removalTimeLocal = moment(obj.removalTime)
      .utc()
      .local()
      .fromNow()
  }
  if (!obj.id && obj.taskId) {
    obj.id = obj.taskId
  }
  if (obj.taskHeader) obj.approvalHeader = obj.taskHeader

  return obj
}

const actions = {
  setTasks({ commit }, tasks) {
    commit('setTasks', tasks)
  },
  async saveTask(context, task) {
    let response = await axios.put('/api/core/task/' + task.id, task)
    return response
  },
  async replicateEngineTask(context, taskId) {
    let response = await axios.post(
      `/api/core/tasks/sync/engine/replicate/${taskId}`
    )
    return response
  },
  async replicateTask(context, id) {
    let response = await axios.get(`/api/v1/userTasks/${id}/replicate`)
    return response.data
  },

  async claimTask(context, input) {
    let response = await axios.post(
      '/api/core/task/' + input.id + '/claim',
      input.body
    )
    return response
  },

  async unclaimTask(context, taskId) {
    let response = axios.post('/api/core/task/' + taskId + '/unclaim', {})
    return response
  },

  async completeTask(context, input) {
    let response = await axios.post(
      '/api/core/task/' + input.id + '/complete',
      input.body
    )
    return response
  },

  async completeTaskInProgress(context, input) {
    let response = await axios.post(
      '/api/core/task/' + input.id + '/complete-in-progress',
      input.body
    )
    return response
  },

  async killUserTask(context, input) {
    let response = await axios.post('/api/v1/userTasks/kill/' + input.id)
    return response
  },

  async completeTaskDirect({ commit }, input) {
    commit('setTaskInProgress', input.id)
    let response = await axios.post(
      '/api/core/task/' + input.id + '/complete/' + input.approved,
      input.body
    )
    return response
  },

  async userTaskHistoryDownload(context, url) {
    let response = await axios.get(url)
    return response.data
  },

  async userTaskHistoryDownloadCount(context, url) {
    let response = await axios.get(url)
    return response.data
  },

  async delegateTask(context, input) {
    let response = axios.post(
      '/api/core/task/' + input.id + '/delegate',
      input.body
    )
    return response
  },

  async assignTaskByAdmin(context, input) {
    let response = axios.post(
      '/api/core/task/' + input.id + '/delegate',
      input.body
    )
    return response
  },

  async createTask(context, task) {
    let response = await axios.post('/api/core/task', task)
    return response
  },

  async createSupportTask(context, task) {
    let response = await axios.post('/api/core/supportTask', task)
    return response
  },

  async addTaskComment(context, input) {
    let response = await axios.post(
      '/api/core/task/' + input.id + '/comment',
      input.body
    )
    return response
  },

  async fetchTaskExecution({ commit }, task) {
    if (task === null) return

    commit('setTaskExecution', {})
    let response = await axios.get('/api/core/task/' + task.id + '/form')
    if (response.data) {
      let taskFormModel = response.data
      let execution = processResp(taskFormModel)
      commit('setTaskExecution', execution)
      return taskFormModel
    }
  },

  async fetchTaskCandidateUsers({ commit }, task) {
    commit('setTaskCandidateUsers', [])
    let response = await axios.get(
      '/api/core/task/' + task.id + '/candidateUsers'
    )

    let candidateUsers = response.data
    commit('setTaskCandidateUsers', candidateUsers)
    return candidateUsers
  },

  resetTaskComments({ commit }) {
    commit('setTaskComments', [])
  },

  async fetchTaskComments({ commit }, id) {
    let response = await axios.get('/api/core/task/' + id + '/comment')
    let comments = [...response.data]
    comments = comments.map(tasks => processResp(tasks))
    commit('setTaskComments', comments)
    return comments
  },

  async fetchClaimedTasks({ commit }, params) {
    let response = await axios.get(
      `/api/v1/userTasks/me?projection=withApprovalDetails&${params}`
    )
    let tasks = [...response.data._embedded.userTasks]
    tasks = tasks.map(tasks => processResp(tasks))
    commit('setClaimedTasks', tasks)
    let taskCount = response.data.page.totalElements
    commit('setTotalAssignedTasks', taskCount)
    return tasks
  },

  async fetchSetClaimedGroupTaskItems({ commit }, params) {
    let response = await axios.get(
      `/api/v1/userTasks/me?projection=withApprovalDetails&${params}`
    )
    let tasks = [...response.data._embedded.userTasks]
    tasks = tasks.map(tasks => processResp(tasks))
    commit('setClaimedGroupTaskItems', tasks)
    let taskCount = response.data.page.totalElements
    commit('setTotalClaimedGroupTaskItems', taskCount)
    return tasks
  },

  async appendSetClaimedGroupTaskItems({ commit }, params) {
    let response = await axios.get(
      `/api/v1/userTasks/me?projection=withApprovalDetails&${params}`
    )
    let tasks = [...response.data._embedded.userTasks]
    tasks = tasks.map(tasks => processResp(tasks))
    commit('addClaimedGroupTaskItems', tasks)
    let taskCount = response.data.page.totalElements
    commit('setTotalClaimedGroupTaskItems', taskCount)
    return tasks
  },

  async fetchSetUnClaimedGroupTaskItems({ commit }, params) {
    let response = await axios.get(
      `/api/v1/userTasks/group-tasks?projection=withApprovalDetails&${params}`
    )
    let tasks = [...response.data._embedded.userTasks]
    tasks = tasks.map(tasks => processResp(tasks))
    commit('setUnClaimedGroupTaskItems', tasks)
    let taskCount = response.data.page.totalElements
    commit('setTotalUnClaimedGroupTaskItems', taskCount)
    return tasks
  },

  async appendSetUnClaimedGroupTaskItems({ commit }, params) {
    let response = await axios.get(
      `/api/v1/userTasks/group-tasks?projection=withApprovalDetails&${params}`
    )
    let tasks = [...response.data._embedded.userTasks]
    tasks = tasks.map(tasks => processResp(tasks))
    commit('addUnClaimedGroupTaskItems', tasks)
    let taskCount = response.data.page.totalElements
    commit('setTotalUnClaimedGroupTaskItems', taskCount)
    return tasks
  },

  async completeTaskListDirect(context, input) {
    let response = await axios.post(
      `/api/v1/userTasks/me/complete?${input.urlParams}`,
      input.body
    )
    return [...response.data]
  },

  async claimAllTask(context, req) {
    let response = await axios.post(
      `/api/v1/userTasks/bulk/claim?${req.urlParams}`,
      req.body
    )
    return [...response.data]
  },

  async setAllTasksInProgress(context, urlParams) {
    let response = await axios.post(
      `/api/v1/userTasks/bulk/set-in-progress?${urlParams}`
    )
    return [...response.data]
  },

  async fetchTaskGroups({ commit }) {
    let response = await axios.get(`/api/v1/userTasks/me/taskGroups`)
    let taskGroups = [...response.data]
    commit('setTaskGroups', taskGroups)
    return taskGroups
  },

  async fetchTaskGroupsByGroup({ commit }) {
    let response = await axios.get(`/api/v1/userTasks/group-tasks/taskGroups`)
    let taskGroups = [...response.data]
    commit('setTaskGroups', taskGroups)
    return taskGroups
  },

  async fetchTaskGroupHeaders({ commit }, params) {
    let response = await axios.get(
      `/api/v1/userTasks/me/taskGroupHeaders?${params}`
    )
    let taskGroupHeaders = [...response.data]
    commit('setTaskGroupHeader', taskGroupHeaders)
    return taskGroupHeaders
  },

  async fetchTaskGroupHeadersByGroup({ commit }, params) {
    let response = await axios.get(
      `/api/v1/userTasks/group-tasks/taskGroupHeaders?${params}`
    )
    let taskGroupHeaders = [...response.data]
    commit('setTaskGroupHeader', taskGroupHeaders)
    return taskGroupHeaders
  },

  async getTaskFormDetails({ commit }, payload) {
    commit('setTask', {})
    let response = await axios.get(
      `/api/v1/userTasks/${payload.id}?projection=withFormDetail`
    )
    let task = response.data
    task = processResp(task)
    commit('setTask', task)
    return task
  },
  async returnTasksDetails(context, hexId) {
    let response = await axios.get(`/api/v1/userTasks/${hexId}`)
    let task = response.data
    return processResp(task)
  },
  async getUserTaskDetails({ commit }, hexId) {
    commit('setUserTask', {})
    let response = await axios.get(`/api/v1/userTasks/${hexId}`)
    let task = response.data
    task = processResp(task)
    commit('setUserTask', task)
    return task
  },

  async fetchTasksInProgress({ commit }, params) {
    commit('setTasksForMaintenance', [])
    let response = await axios.get(
      `/api/v1/userTasks/inProgress?projection=withApprovalDetails${params}`
    )

    let tasks = [...response.data._embedded.userTasks]
    tasks = tasks.map(tasks => processResp(tasks))
    commit('setTasksForMaintenance', tasks)
    let taskCount = response.data.page.totalElements
    return taskCount
  },

  async fetchTasksForAdmin({ commit }, params) {
    commit('setTasksForMaintenance', [])
    let response = await axios.get(
      `/api/core/admin/tasks?${params}&sortBy=created&sortOrder=desc`
    )
    let tasks = [...response.data]
    tasks = tasks.map(tasks => processResp(tasks))
    commit('setTasksForMaintenance', tasks)
    return tasks
  },

  async fetchTasksCountForAdmin({ commit }, params) {
    commit('setTasksForMaintenance', [])
    let response = await axios.get(`/api/core/admin/tasks/count?${params}`)
    return response.data
  },

  async fetchOwnTasks({ commit }, params) {
    if (!params) {
      params = {}
      params.firstResult = 0
      params.maxResults = 20
    }
    let response = await axios.get(
      `/api/core/owntasks?firstResult=${params.firstResult ||
        0}&maxResults=${params.maxResults || 20}&sortBy=created&sortOrder=desc`
    )
    let tasks = [...response.data]
    tasks = tasks.map(tasks => processResp(tasks))
    commit('setOwnTasks', tasks)
    return tasks
  },

  async fetchAllOwnTasks({ commit }) {
    let response = await axios.get(
      `/api/core/owntasks?sortBy=created&sortOrder=desc`
    )
    let tasks = [...response.data]
    tasks = tasks.map(tasks => processResp(tasks))
    commit('setOwnTasks', tasks)
    return tasks
  },

  async fetchUnClaimedTasks({ commit }, params) {
    let response = await axios.get(
      `/api/v1/userTasks/group-tasks?projection=withApprovalDetails&${params}`
    )
    let tasks = [...response.data._embedded.userTasks]
    tasks = tasks.map(tasks => processResp(tasks))
    commit('setUnclaimedTasks', tasks)
    let taskCount = response.data.page.totalElements
    commit('setTotalGroupTasks', taskCount)
    return tasks
  },

  async appendClaimedTasks({ commit }, params) {
    let response = await axios.get(
      `/api/v1/userTasks/me?projection=withApprovalDetails&${params}`
    )
    let tasks = [...response.data._embedded.userTasks]
    tasks = tasks.map(tasks => processResp(tasks))
    commit('addClaimedTasks', tasks)
    return tasks
  },

  async fetchTask({ commit }, taskId) {
    commit('setSelectedTaskForApproval', null)
    let response = await axios.get(`/api/core/task/${taskId}`)
    let task = response.data
    task = processResp(task)
    commit('setSelectedTaskForApproval', task)
    return task
  },

  async fetchTaskForAdmin({ commit }, taskId) {
    commit('setTasksForMaintenance', [])
    let response = await axios.get(`/api/core/task/${taskId}`)
    let task = response.data
    task = processResp(task)
    let taskForMaintenance = []
    taskForMaintenance.push(task)
    commit('setTasksForMaintenance', taskForMaintenance)
    return task
  },
  async appendOwnTasks({ commit }, params) {
    if (!params) {
      params = {}
      params.firstResult = 0
      params.maxResults = 20
    }
    let response = await axios.get(
      `/api/core/owntasks?firstResult=${params.firstResult ||
        0}&maxResults=${params.maxResults || 20}&sortBy=created&sortOrder=desc`
    )
    let tasks = [...response.data]
    tasks = tasks.map(tasks => processResp(tasks))
    commit('addOwnTasks', tasks)
    return tasks
  },
  async appendUnclaimedTasks({ commit }, params) {
    let response = await axios.get(
      `/api/v1/userTasks/group-tasks?projection=withApprovalDetails&${params}`
    )
    let tasks = [...response.data._embedded.userTasks]
    tasks = tasks.map(tasks => processResp(tasks))
    commit('addUnclaimedTasks', tasks)
    return tasks
  },

  async fetchTasksHistory({ commit }, urlParams) {
    let url = '/api/v1/userTasks?projection=withHeaderDetails'
    if (urlParams !== undefined && urlParams !== null) {
      url = url + '&' + urlParams
    }
    let response = await axios.get(url)
    if (response.data._embedded) {
      let tasks = [...response.data._embedded.userTasks]
      tasks = tasks.map(tasks => processResp(tasks))
      commit('setTaskHistory', tasks)
      commit('setTotalTasks', response.data.page.totalElements)
      return tasks
    }
  },

  async resetRelatedTask({ commit }) {
    commit('setRelatedTasks', [])
  },

  async fetchRelatedTasks({ commit }, urlParams) {
    commit('setRelatedTasks', [])
    let url = '/api/v1/userTasks?projection=withHeaderDetails'
    if (urlParams !== undefined && urlParams !== null) {
      url = url + '&' + urlParams
    }
    let response = await axios.get(url)
    if (response.data._embedded) {
      let tasks = [...response.data._embedded.userTasks]
      tasks = tasks.map(tasks => processResp(tasks))
      commit('setRelatedTasks', tasks)
      return tasks
    }
  },

  async fetchTasksCount(context, urlParams) {
    let url = '/api/v1/userTasks/count'
    if (urlParams !== undefined && urlParams !== null) {
      url = url + '?' + urlParams
    }
    let response = await axios.get(url)
    return response.data
  },

  async fetchTasksCountByFormKey({ commit }, urlParams) {
    let url = '/api/v1/userTasks/countByFormKey'
    if (urlParams !== undefined && urlParams !== null) {
      url = url + '?' + urlParams
    }
    let response = await axios.get(url)
    let countByFormKey = []
    if (
      response.data._embedded &&
      response.data._embedded.integerMeasureByStringModels
    ) {
      countByFormKey = [...response.data._embedded.integerMeasureByStringModels]
    }
    commit('setTaskCountByFormKey', countByFormKey)
  },

  async fetchTasksCountByFormKeyByGroup({ commit }, urlParams) {
    let url = '/api/v1/userTasks/countByFormKeyByGroup'
    if (urlParams !== undefined && urlParams !== null) {
      url = url + '?' + urlParams
    }
    let response = await axios.get(url)
    let countByFormKey = []
    if (response.data._embedded.integerMeasureByStringModels) {
      countByFormKey = [...response.data._embedded.integerMeasureByStringModels]
    }
    commit('setTaskCountByFormKey', countByFormKey)
  },

  async fetchAssociatedFormKey({ commit }, urlParams) {
    let url = '/api/v1/userTasks/formKeys'
    if (urlParams !== undefined && urlParams !== null) {
      url = url + '?' + urlParams
    }
    let response = await axios.get(url)
    commit('setAssociatedFormKeys', response.data)
    return response.data
  },
  async fetchAssociatedFormKeyByGroup({ commit }, urlParams) {
    let url = '/api/v1/userTasks/formKeysByGroup'
    if (urlParams !== undefined && urlParams !== null) {
      url = url + '?' + urlParams
    }
    let response = await axios.get(url)
    commit('setAssociatedFormKeys', response.data)
    return response.data
  },

  async fetchTotalTaskCount({ commit }, urlParams) {
    let response = await axios.get('/api/v1/userTasks/count?' + urlParams)
    if (response.data) {
      let count = response.data
      commit('setTotalTasks', count)
      return count
    }
  },
  async fetchTotalAssignedTaskCount({ commit }, urlParams) {
    let response = await axios.get('/api/core/tasks/count?' + urlParams)
    if (response.data) {
      let count = response.data.count
      commit('setTotalAssignedTasks', count)
      return count
    }
  },
  async fetchTotalGroupTaskCount({ commit }, urlParams) {
    let response = await axios.get('/api/core/tasks/group/count?' + urlParams)
    if (response.data) {
      let count = response.data.count
      commit('setTotalGroupTasks', count)
      return count
    }
  },
  async fetchTotalOwnTaskCount({ commit }, urlParams) {
    let response = await axios.get('/api/core/tasks/own/count?' + urlParams)
    if (response.data) {
      let count = response.data.count
      commit('setTotalOwnTasks', count)
      return count
    }
  }
}

export default {
  state,
  mutations,
  actions
}
